import { createCachedSelector } from "re-reselect";

import { getSegmentsWithNoVehicleLayout } from "./get-segments-with-no-vehicle-layout";
import { getSegmentsWithUnknownVehicleLayout } from "./get-segments-with-unknown-vehicle-layout";
import { getSegmentsWithVehicleLayout } from "./get-segments-with-vehicle-layout";
import { getInventoryReady } from "../state-accessors";

export const isTripVehicleAvailable = createCachedSelector(
  [
    getInventoryReady,
    getSegmentsWithVehicleLayout,
    getSegmentsWithNoVehicleLayout,
    getSegmentsWithUnknownVehicleLayout
  ],
  (
    inventory_ready,
    vehicles_with_layout,
    vehicles_with_no_layout,
    vehicles_with_unknown_layout
  ) => {
    if (!inventory_ready) {
      return undefined;
    }

    if (vehicles_with_no_layout.length > 0) {
      return false;
    }

    if (vehicles_with_unknown_layout.length > 0) {
      return undefined;
    }

    return vehicles_with_layout.length > 0;
  }
)((_state, trip_id) => trip_id);
